import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BreadcrumbProvider } from "../../hooks/BreadCrumbContext";
import { ModalProvider } from "../../hooks/ModalContext";
import { PermissionProvider } from "../../hooks/PermissionContext";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import UserSidebar from "../../components/UserSidebar";
import { menuItems } from "../../utils/menuItems";

interface Props {
  children: JSX.Element;
}

const Main: React.FC<Props> = (props: Props) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isUserSidebarOpen, setIsUserSidebarOpen] = useState(false);
  const [headerTitle, setHeaderTitle] = useState("Cadastros");
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const updateLayout = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      setIsSidebarOpen(!mobile);
    };

    updateLayout();
    window.addEventListener("resize", updateLayout);

    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;
    let foundTitle = "Cadastros";

    for (const item of menuItems) {
      if (item.path === currentPath) {
        foundTitle = item.title;
        break;
      }
      if (item.submenu) {
        for (const subItem of item.submenu) {
          if (subItem.path === currentPath) {
            foundTitle = item.title;
            break;
          }
        }
      }
    }
    setHeaderTitle(foundTitle);
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [location, isMobile]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleUserSidebar = () => {
    setIsUserSidebarOpen(!isUserSidebarOpen);
  };

  return (
    <div className="app-shell flex flex-col w-full h-dvh overflow-hidden bg-gray-100">
      <Header toggleSidebar={toggleSidebar} toggleUserSidebar={toggleUserSidebar} title={headerTitle} />
      <UserSidebar isOpen={isUserSidebarOpen} onClose={() => setIsUserSidebarOpen(false)} />
      <div className="flex flex-1 min-h-0 overflow-hidden">
        {isMobile && isSidebarOpen && (
          <button
            type="button"
            aria-label="Fechar menu"
            className="fixed inset-0 z-30 bg-black/50 lg:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
        <Sidebar isOpen={isSidebarOpen} isMobile={isMobile} onClose={() => setIsSidebarOpen(false)} />
        <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
          <PermissionProvider>
            <ModalProvider>
              <BreadcrumbProvider>
                <div className="app-main-content flex-1 min-h-0 overflow-auto">
                  {/* <SubNav
                    isVisibleActions={
                      !window.location.pathname.includes("adicionar")
                    }
                  /> */}
                  <div className="min-h-full relative">
                    {props.children}
                  </div>
                </div>
              </BreadcrumbProvider>
            </ModalProvider>
          </PermissionProvider>
        </div>
      </div>
    </div>
  );
};

export default Main;
